import React, { useEffect, useState } from 'react';

import ResumeJourneyCard from './resumeJourneyCard';
import { useResumeJourney } from './resumeJourney.controller';
import { ResumeJourneyType } from './resumeJourney.type';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';
import ResumeJourneyCarousel from './component/resumeJourneyCarousel';

const ResumeJourney = () => {
  const { dashboardLabels } = useDashboard();
  const cmsData = dashboardLabels.resumeJourneyCmsData;
  const [resumeNudges, setResumeNudges] = useState<ResumeJourneyType[]>([]);
  const { getResumeNudges } = useResumeJourney();

  useEffect(() => {
    const nudges = getResumeNudges(cmsData.expiryDateDifference);
    setResumeNudges(nudges);
  }, [getResumeNudges]);

  const onCrossClick = (index: number) => {
    const updatedNudges = [...resumeNudges];
    updatedNudges.splice(index, 1);
    setResumeNudges(updatedNudges);
  };

  return (
    <ResumeJourneyCarousel
      title={cmsData.title}
      cards={resumeNudges}
      Component={ResumeJourneyCard}
      onCrossClick={(index) => {
        onCrossClick(index);
      }}
    />
  );
};

export default ResumeJourney;
